import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import Layout from "../components/Layout";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/actions/cart";
import { toast } from "react-toastify";
import { MEDALLION_TYPES } from "../constants/medallionTypes";

export default function Medallion() {
  const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
        style={{ transform: "rotate(180deg)" }}
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const reviewslide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const [index, setIndex] = useState(3); // middle image starts selected
  const total = 8; // total number of images
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [medallionName, setMedallionName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getClass = (i) => {
    const diff = (i - index + total) % total;
    switch (diff) {
      case 0:
        return "selected";
      case 1:
        return "next";
      case 2:
        return "nextRightSecond";
      case total - 1:
        return "prev";
      case total - 2:
        return "prevLeftSecond";
      default:
        return diff > 2 ? "hideRight" : "hideLeft";
    }
  };

  const handleAddToCart = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Login required");
      return;
    }

    if (!medallionName.trim()) {
      toast.error("Please enter a medallion name");
      return;
    }

    setIsLoading(true);
    try {
      const price = selectedQuantity === 1 ? 97 : 179;
      const payload = {
        amount: price.toString(),
        type: MEDALLION_TYPES.HUMAN,
        name: medallionName,
        buy: selectedQuantity,
      };

      const response = await dispatch(addToCart(payload)).unwrap();
      if (response?.status === 200 && response?.link) {
        window.location.href = response.link;
      } else {
        toast.success(response?.message || "Added to cart successfully!");
      }
    } catch (error) {
      console.error("Add to Cart Error:", error);
      toast.error(error?.message || "Failed to add to cart");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Layout>
      <section className="memory-medallion">
        <Container>
          <div className="memory-medallion-main">
            <Row>
              <Col lg={6} className="">
                <div className="memory-medallion-slider">
                  <div className="">
                    {/* <ul>
                      <li>
                        <img src={require("../assets/images/Frame1.png")} />
                      </li>
                      <li>
                        <img src={require("../assets/images/Frame1.png")} />
                      </li>
                      <li>
                        <img src={require("../assets/images/Frame1.png")} />
                      </li>
                      <li>
                        <img src={require("../assets/images/Frame1.png")} />
                      </li>
                    </ul> */}
                  </div>
                  <div className="">
                    <img src={require("../assets/images/HumanFrame.png")} />
                  </div>
                </div>
              </Col>
              <Col lg={6} className="">
                <div className="memory-medallion-invoice">
                  <h2>Memory Medallion™</h2>
                  <div className="medallion-stars">
                    <ul>
                      <li>
                        <img
                          src={require("../assets/images/star.svg").default}
                        />
                      </li>
                      <li>
                        <img
                          src={require("../assets/images/star.svg").default}
                        />
                      </li>
                      <li>
                        <img
                          src={require("../assets/images/star.svg").default}
                        />
                      </li>
                      <li>
                        <img
                          src={require("../assets/images/star.svg").default}
                        />
                      </li>
                      <li>
                        <img
                          src={require("../assets/images/star.svg").default}
                        />
                      </li>
                    </ul>
                    <p>(4 Reviews)</p>
                  </div>
                  <h4>
                    $97.99 <span>$147.00</span>
                  </h4>
                  <p>
                    Preserve your loved one's legacy with a Pixels & Hearts
                    Memory Medallion™
                  </p>
                  <ul>
                    <li>Share your favourite photos and videos</li>
                    <li>Add a biography and family tree</li>
                    <li>Post heartfelt tributes</li>
                    <li>Lifetime warranty</li>
                    <li>No monthly fees</li>
                  </ul>
                  <div
                    className={`price-tag-contain ${
                      selectedQuantity === 1 ? "active" : ""
                    } mb-3`}
                    onClick={() => setSelectedQuantity(1)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="">
                      <h3>Buy 1</h3>
                      <h4>$97</h4>
                    </div>
                    <div className="">
                      <p>You save $50</p>
                      <p>$147</p>
                    </div>
                  </div>
                  <div
                    className={`price-tag-contain ${
                      selectedQuantity === 2 ? "active" : ""
                    }`}
                    onClick={() => setSelectedQuantity(2)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="">
                      <h3>Buy 2</h3>
                      <h4>$179</h4>
                    </div>
                    <div className="">
                      <p>You save $115</p>
                      <p>$294</p>
                    </div>
                  </div>
                  <div className="my-3">
                    <input
                      type="text"
                      placeholder="Enter medallion name"
                      value={medallionName}
                      onChange={(e) => setMedallionName(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="add-to-cart" onClick={handleAddToCart} disabled={isLoading}>
                    {isLoading ? 'Loading...' : 'Pay'}
                  </button>
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>What’s included?</Accordion.Header>
                      <Accordion.Body>
                        <ul>
                          <li>Memory Medallion™</li>
                          <li>Lifetime Online Memories page</li>
                          <li>High-strength adhesive</li>
                          <li>Alcohol wipe</li>
                          <li>Summer Rose custom box</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Memories page feature</Accordion.Header>
                      <Accordion.Body>
                        <ul>
                          <li>Share your favourite photo and videos</li>
                          <li>Add a biography and family tree</li>
                          <li> Post heartfelt tributes</li>
                          <li> Lifetime warranty </li>
                          <li>No monthly fees</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>How does it works?</Accordion.Header>
                      <Accordion.Body>
                        <ul>
                          <li>Scan your Memory Medallion™ QR code</li>
                          <li>Create your Memories Page for your loved one </li>
                          <li>
                            Install the QR code and share it with family and
                            friends
                          </li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>Dimensions</Accordion.Header>
                      <Accordion.Body>
                        <ul>
                          <li>51.5mm x 51.5mm x 1.5mm</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>Materials</Accordion.Header>
                      <Accordion.Body>
                        <ul>
                          <li>High-Quality anodised aluminium</li>
                          <li>Made in Australia</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="p-80">
        <Container>
          <div className="living-tribute-data">
            <h2>Reviews</h2>

            <div className="review-slide">
              <Slider {...reviewslide}>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="our-client-card">
                    <div>
                      <img src={require("../assets/images/sarahjohnson.png")} />
                      <h2>Marry Welsom</h2>
                      <p>Founder and CEO OF PREMIUM </p>
                    </div>
                    <div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ecommodo
                        consequat. Duis aute irure dolor in reprehenderit{" "}
                      </p>
                      <ul>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                        <li>
                          <img
                            src={require("../assets/images/star.svg").default}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </Container>
      </section>

      <section className="p-80 pt-2">
        <Container>
          <div className="feature-medallion">
            <div className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M35.6252 21.8749C34.3752 28.1249 29.663 34.009 23.0485 35.3247C16.434 36.6404 9.72184 33.5637 6.40092 27.6939C3.07999 21.8243 3.89984 14.4862 8.43432 9.49419C12.9688 4.50211 20.6252 3.12491 26.8752 5.62491"
                  stroke="#2F4E77"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.375 19.375L20.625 25.625L35.625 9.375"
                  stroke="#2F4E77"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h5>Lifetime Warranty</h5>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M10.5984 13.0132L13.255 12.1999C13.4644 12.1359 13.6843 12.1137 13.9022 12.1347C14.1201 12.1556 14.3318 12.2193 14.5251 12.3221C14.7184 12.4249 14.8895 12.5647 15.0288 12.7336C15.168 12.9025 15.2727 13.0972 15.3367 13.3066C15.4007 13.5159 15.4229 13.7358 15.4019 13.9537C15.3809 14.1716 15.3173 14.3833 15.2145 14.5766C15.1117 14.7699 14.9719 14.9411 14.803 15.0803C14.6341 15.2196 14.4394 15.3242 14.23 15.3882L7.85503 17.3382C7.64557 17.4023 7.42555 17.4244 7.20754 17.4033C6.98953 17.3823 6.7778 17.3185 6.58447 17.2155C6.39114 17.1126 6.21999 16.9726 6.08082 16.8034C5.94164 16.6343 5.83717 16.4394 5.77336 16.2299L3.82336 9.85489C3.75934 9.64554 3.73718 9.42563 3.75815 9.20772C3.77912 8.9898 3.8428 8.77816 3.94557 8.58485C4.04833 8.39155 4.18816 8.22039 4.35708 8.08113C4.52599 7.94187 4.72068 7.83724 4.93003 7.77322C5.35283 7.64393 5.80967 7.68789 6.20006 7.89543C6.59045 8.10297 6.8824 8.45709 7.0117 8.87989L7.74503 11.2816C11.7584 5.09989 19.72 2.44155 26.7884 5.33822C28.9023 6.20456 30.8006 7.52366 32.3498 9.2027C33.8989 10.8817 35.0613 12.8799 35.755 15.0566C35.8262 15.2662 35.8548 15.488 35.8393 15.7088C35.8237 15.9297 35.7644 16.1453 35.6646 16.3429C35.5648 16.5406 35.4267 16.7164 35.2582 16.8601C35.0898 17.0037 34.8944 17.1124 34.6835 17.1797C34.4725 17.247 34.2503 17.2717 34.0298 17.2521C33.8092 17.2326 33.5948 17.1693 33.3989 17.066C33.2031 16.9627 33.0298 16.8214 32.8892 16.6504C32.7486 16.4793 32.6435 16.282 32.58 16.0699C31.8759 13.8588 30.5608 11.892 28.7865 10.3966C27.0122 8.90107 24.8512 7.93792 22.5528 7.6183C20.2545 7.29868 17.9126 7.63563 15.7976 8.59024C13.6826 9.54485 11.8791 11.0782 10.5984 13.0132ZM31.1434 26.6716L28.185 27.4099C27.9708 27.4686 27.747 27.484 27.5268 27.455C27.3066 27.426 27.0944 27.3533 26.9027 27.2411C26.7109 27.129 26.5436 26.9796 26.4104 26.8019C26.2772 26.6241 26.1809 26.4215 26.1272 26.206C26.0734 25.9905 26.0632 25.7664 26.0973 25.5469C26.1314 25.3274 26.209 25.117 26.3256 24.9279C26.4421 24.7388 26.5953 24.575 26.7761 24.4459C26.9569 24.3169 27.1617 24.2253 27.3784 24.1766L33.45 22.6616C33.7665 22.5114 34.1222 22.4647 34.4667 22.5282C34.7986 22.5719 35.1097 22.7145 35.3594 22.9374C35.6091 23.1604 35.7859 23.4534 35.8667 23.7782L37.48 30.2449C37.5756 30.6696 37.5012 31.1149 37.2727 31.4854C37.0443 31.856 36.6799 32.1225 36.2575 32.2279C35.8351 32.3333 35.3882 32.2692 35.0124 32.0494C34.6367 31.8295 34.3618 31.4714 34.2467 31.0516L33.6967 28.8482C32.092 31.1575 29.8941 32.9912 27.3347 34.1563C24.7753 35.3213 21.949 35.7744 19.1536 35.468C16.3583 35.1616 13.6973 34.1069 11.451 32.4151C9.20478 30.7233 7.45638 28.457 6.39003 25.8549L5.9567 24.7982C5.87374 24.5957 5.8315 24.3787 5.83238 24.1598C5.83326 23.941 5.87725 23.7244 5.96183 23.5225C6.04641 23.3206 6.16992 23.1374 6.32532 22.9832C6.48072 22.829 6.66496 22.707 6.86753 22.6241C7.27663 22.4565 7.73552 22.4584 8.14325 22.6292C8.34514 22.7138 8.5284 22.8373 8.68255 22.9927C8.83671 23.1481 8.95874 23.3323 9.0417 23.5349L9.47503 24.5899C10.3246 26.6629 11.7242 28.4646 13.5227 29.8005C15.3212 31.1363 17.4504 31.9557 19.6805 32.1701C21.9106 32.3845 24.1569 31.9859 26.177 31.0171C28.1972 30.0484 29.9144 28.5447 31.1434 26.6716Z"
                  fill="#2F4E77"
                />
              </svg>

              <h5>No Monthly Fees</h5>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M9.1665 23.3333C10.127 23.3331 11.0582 23.6647 11.8023 24.2722C12.5464 24.8796 13.0577 25.7254 13.2498 26.6666H24.9998V9.99992H6.6665C5.78245 9.99992 4.9346 10.3511 4.30948 10.9762C3.68436 11.6014 3.33317 12.4492 3.33317 13.3333V26.6666H5.08317C5.27528 25.7254 5.78666 24.8796 6.53075 24.2722C7.27485 23.6647 8.20596 23.3331 9.1665 23.3333ZM9.1665 31.6666C8.20596 31.6668 7.27485 31.3351 6.53075 30.7277C5.78666 30.1202 5.27528 29.2744 5.08317 28.3333H1.6665V13.3333C1.6665 12.0072 2.19329 10.7354 3.13097 9.79772C4.06865 8.86004 5.34042 8.33325 6.6665 8.33325H24.9998C25.4419 8.33325 25.8658 8.50885 26.1783 8.82141C26.4909 9.13397 26.6665 9.55789 26.6665 9.99992V13.3333H31.6665L36.6665 19.9999V28.3333H33.2498C33.0586 29.2752 32.5476 30.122 31.8034 30.7302C31.0592 31.3385 30.1276 31.6708 29.1665 31.6708C28.2054 31.6708 27.2738 31.3385 26.5296 30.7302C25.7854 30.122 25.2744 29.2752 25.0832 28.3333H13.2498C13.0577 29.2744 12.5464 30.1202 11.8023 30.7277C11.0582 31.3351 10.127 31.6668 9.1665 31.6666ZM9.1665 24.9999C8.50346 24.9999 7.86758 25.2633 7.39874 25.7322C6.9299 26.201 6.6665 26.8369 6.6665 27.4999C6.6665 28.163 6.9299 28.7988 7.39874 29.2677C7.86758 29.7365 8.50346 29.9999 9.1665 29.9999C9.82955 29.9999 10.4654 29.7365 10.9343 29.2677C11.4031 28.7988 11.6665 28.163 11.6665 27.4999C11.6665 26.8369 11.4031 26.201 10.9343 25.7322C10.4654 25.2633 9.82955 24.9999 9.1665 24.9999ZM29.1665 23.3333C30.127 23.3331 31.0582 23.6647 31.8023 24.2722C32.5464 24.8796 33.0577 25.7254 33.2498 26.6666H34.9998V20.5333L34.5998 19.9999H26.6665V24.1666C27.3665 23.6499 28.2332 23.3333 29.1665 23.3333ZM29.1665 24.9999C28.5035 24.9999 27.8676 25.2633 27.3987 25.7322C26.9299 26.201 26.6665 26.8369 26.6665 27.4999C26.6665 28.163 26.9299 28.7988 27.3987 29.2677C27.8676 29.7365 28.5035 29.9999 29.1665 29.9999C29.8295 29.9999 30.4654 29.7365 30.9343 29.2677C31.4031 28.7988 31.6665 28.163 31.6665 27.4999C31.6665 26.8369 31.4031 26.201 30.9343 25.7322C30.4654 25.2633 29.8295 24.9999 29.1665 24.9999ZM26.6665 14.9999V18.3333H33.3332L30.8332 14.9999H26.6665Z"
                  fill="#2F4E77"
                />
              </svg>
              <h5>Worldwide Delivery</h5>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M35 18.3334C35 27.5834 28.6 36.2334 20 38.3334C11.4 36.2334 5 27.5834 5 18.3334V8.33342L20 1.66675L35 8.33342V18.3334ZM20 35.0001C26.25 33.3334 31.6667 25.9001 31.6667 18.7001V10.5001L20 5.30008L8.33333 10.5001V18.7001C8.33333 25.9001 13.75 33.3334 20 35.0001ZM25.0833 26.6667L19.95 23.5834L14.8333 26.6667L16.1833 20.8334L11.6667 16.9334L17.6333 16.4167L19.95 10.9167L22.2833 16.4001L28.25 16.9167L23.7167 20.8334L25.0833 26.6667Z"
                  fill="#2F4E77"
                />
              </svg>
              <h5>100% Quality Guarantee</h5>
            </div>
          </div>
        </Container>
      </section>
    </Layout>
  );
}
